import React, { Component } from 'react';

export default class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: ''
        }
    }

    render() {
        let Followers = [];
        let Name = '';
        let pageCounter = 1;
        let link = '';

        const fetchData = async () => {
            const followers = document.getElementById('followers');
            const response = await fetch(`${link}`);
            if (response.status === 404) {
                followers.innerHTML = `<div id="alert">User Not Found</div>`;
                return;
            }
            else if (response.status === 403) {
                followers.innerHTML = `<div id="alert">Too many requests, try again later</div>`;
                return;
            }
            const data = await response.json();
            showUsers(data);
        }

        const showUsers = (data) => {
            const followers = document.getElementById('followers');
            followers.innerHTML = '';
            data.forEach(user => {
                const follower = document.createElement('div');
                follower.classList.add('follower');
                follower.innerHTML = `
                <div id="user-info">
                <img src="${user.avatar_url}" id="avatar" alt="${user.login}" />
                <div id="namecontainer">
                <p id="name"><a href="https://github.com/${user.login}" target="blank"> ${user.login}</a></p>
                <p id="${user.login}">Buddy 🟢</p>
                </div>
                </div>
                `;
                followers.appendChild(follower);
                Followers.push(user.login);
            });
            checkIfFollowing();
        }

        const checkIfFollowing = () => {
            Followers.forEach(user => {
                const follower = document.querySelector(`#${user}`);

                const LoadFollow = async () => {
                    const response2 = await fetch(`https://api.github.com/users/${user}/following/${Name}`);
                    const data2 = await response2.json();
                    if (data2.message === 'Not Found') {
                        follower.innerHTML = 'Traitor 🔴';
                    }
                }
                LoadFollow();
            });
        }

        const handleChange = (e) => {
            this.setState({ username: e.target.value });
        }

        const handleClick = () => {
            if (this.state.username === '')
                return;
            Name = this.state.username;
            link = `https://api.github.com/users/${this.state.username}/following?per_page=100`;
            fetchData();
        }

        const nextPage = () => {
            pageCounter++;
            link = `https://api.github.com/users/${Name}/following?per_page=100&&page=${pageCounter}`;
            fetchData();
        }

        return (
            <div>
                <h1 id='title'>Know Your Buddies</h1>
                <input placeholder='Enter Your GitHub Username' id='username' onChange={handleChange} type="text" />
                <button className="submitname" onClick={handleClick}>Submit</button>
                <div id="followers">
                    <h3>Note:</h3>
                    <ul id='note'>
                        <li>This will show 100 users at a time</li>
                        <li>Press next to see next 100 users</li>
                        <li>You can check upto 3 times using one IP Adress per day.</li>
                    </ul>
                </div>
                <button type='button' className='next' onClick={nextPage}>Next →</button>
            </div>
        )
    }
}

